import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { weekDaysLong, getWeekDayName } from '../../../helpers/localization/localizationUtils';
import Box from '../../elements/Box';

const DatePickerWeekday = (props) => {
  const { weekday, weekDayFormat } = props;
  const { direction, translate, localizationData, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box
      aria-label={weekDaysLong(translate, localizationData)[weekday]}
      role="columnheader"
      display="table-cell"
      className="front10-date-selector-weekday"
    >
      <Box {...props} className={className} style={style}>
        {getWeekDayName(weekday, weekDayFormat, translate, localizationData)}
      </Box>
    </Box>
  );
};

DatePickerWeekday.propTypes = {
  weekday: PropTypes.number.isRequired,
  /**
   * Font size on the componet
   */
  fontSize: PropTypes.string,
  /**
   * Text align of the componet
   */
  textAlign: PropTypes.string,
  /**
   * Padding of the component
   */
  padding: PropTypes.string,
  /**
   * Define how to show the weekdays
   */
  weekDayFormat: PropTypes.oneOf(['long', 'short', 'oneLetter']),
  /**
   * Border of the component
   */
  border: PropTypes.bool,
  /**
   * Rounded of the component
   */
  rounded: PropTypes.string
};

DatePickerWeekday.defaultProps = {
  fontSize: '4',
  textAlign: 'center',
  padding: '1',
  weekDayFormat: 'long',
  border: true,
  rounded: '@theme:card.rounded'
};
export default DatePickerWeekday;
